var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProviderArrows = function SvgProviderArrows(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#DFF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#35333C",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M15.435 8H8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35333C",
    d: "M12.641 5.215l3.831 2.448a.4.4 0 0 1 0 .674l-3.83 2.448a.22.22 0 0 1-.338-.185v-.18a.4.4 0 0 1 .185-.338L15.748 8l-3.259-2.082a.4.4 0 0 1-.185-.337V5.4a.22.22 0 0 1 .337-.185z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#35333C",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M5.565 13H13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35333C",
    d: "M8.359 15.785l-3.831-2.448a.4.4 0 0 1 0-.674l3.83-2.448a.22.22 0 0 1 .338.185v.18a.4.4 0 0 1-.185.338L5.252 13l3.259 2.082a.4.4 0 0 1 .185.337v.181a.22.22 0 0 1-.337.185z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProviderArrows);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/provider-arrows.a7fcbf60de941e6a43ade7458e38eac6.svg";